import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/main.css";
import servicii from "../images/servicii-img.png";
import smallServicii from "../images/small-servicii.png";
import "../css/main.css";

const SupervizarePsihologieClinica = () => {
  return (
    <div>
      <Header />

      <div className="contributii blog servicii serviciu-page">
        <div className="container">
          <div className="info-section text-b">AWARE</div>
          <h1 className="text-b">Supervizare Psihologie Clinică</h1>
          <p>
            Definitia supervizarii, atat d p d v etimologic cat si practic, este
            de “a supraveghea”.
          </p>
          <p>
            Asta facem si noi in cadrul sedintelor de supervizarea: supraveghem
            activ procesul de devenire profesionala al psihologului clinician.
          </p>
          <p style={{ fontStyle: "italic" }}>
            Supervizarea este o interventie oferita de un membru mai vechi al
            unei profesii unui membru sau mai multor membri ai aceleiasi
            profesii, avand ca obiective simultane:
          </p>
          <p style={{ fontStyle: "italic" }}>
            -sporirea functionarii profesionale a persoanei/persoanelor mai noi
            in profesie
          </p>
          <p style={{ fontStyle: "italic" }}>
            -monitorizarea calitatii serviciilor profesionale oferite clientilor
            de catre acesta persoana/persoane
          </p>
          <p style={{ fontStyle: "italic" }}>(Bernard&Goodyear)</p>
          <p>
            Pentru psihologii cu drept de libera practica, practicant sub
            supervizare in psihologie clinica oferim sprijin informational si
            directiv pentru:
          </p>
          <ul>
            <li>
              aspecte care tin de deschiderea si administrarea cabinetului
            </li>
            <li>
              evaluarea psihologica pe diverse dimensiuni: afectiv,
              comportamental,personaliatea, relatii, coping, etc.
            </li>
            <li>psihodiagnostic</li>
            <li>
              planificarea eficienta a evaluarii psihologice clinice si
              redactarea raportului de evaluare clinica
            </li>
            <li>
              organizarea interventiei psihologice (consiliere psihologica)
            </li>
          </ul>
          <p>
            Si pentru ca in Centrul de psihologie Aware, practicam o viziune
            umanista, ne ingrijim ca viitorul psiholog clinician sa dezvolte o
            buna practica de evaluare psihologica si, totodata, sa vada dincolo
            de aceasta in ceea ce il face unic si de neinlocuit pe cel aflat in
            suferinta.
          </p>
          <p>
            Sedintele de supervizare se desfasoara o data pe luna, 4 ore, pe
            parcursul a 2 ani.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SupervizarePsihologieClinica;
